let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7zlvy")).then(() => parcelRequire('6bpop'));